"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const MiniProviderCardList_styles_1 = require("./MiniProviderCardList.styles");
const useProviderCardUtilities_1 = require("./useProviderCardUtilities");
const util_1 = require("../common/util");
const MiniProviderCardList = ({ createAvailabilityUrl, createProviderUrl, providers, track, viewAvailabilityLinkTarget = '_self', viewProviderLinkTarget = '_self', isProfileDisabled = false, className, renderType = util_1.SIMILAR_PROVIDERS }) => {
    const { viewAvailabilityCallback, viewProviderCallback, viewProviderCTACallback } = (0, useProviderCardUtilities_1.useProviderCardUtilities)({
        track,
        viewAvailabilityLinkTarget,
        viewProviderLinkTarget,
        createAvailabilityUrl,
        createProviderUrl,
        renderType
    });
    return (react_1.default.createElement(MiniProviderCardList_styles_1.ProviderCardList, { className: className }, providers.map((_a) => {
        var _b;
        var { location } = _a, detailedProvider = __rest(_a, ["location"]);
        const key = `${detailedProvider.provider.id}-${(_b = location === null || location === void 0 ? void 0 : location.id) !== null && _b !== void 0 ? _b : ''}`;
        return (react_1.default.createElement(MiniProviderCardList_styles_1.ProviderCard, Object.assign({ key: key, "data-testid": `MiniProviderCardList-Provider-${key}` }, detailedProvider, { onViewAvailability: viewAvailabilityCallback(detailedProvider), onViewProvider: viewProviderCallback(detailedProvider), onViewProviderCTA: viewProviderCTACallback(detailedProvider), viewAvailabilityUrl: createAvailabilityUrl(detailedProvider.provider), viewProviderUrl: createProviderUrl(detailedProvider.provider), compactProviderSpecialties: true, viewAvailabilityLinkTarget: viewAvailabilityLinkTarget, viewProviderLinkTarget: viewProviderLinkTarget, isProfileDisabled: isProfileDisabled })));
    })));
};
exports.default = (0, intl_1.injectIntl)(MiniProviderCardList);
//# sourceMappingURL=MiniProviderCardList.js.map